import { render, staticRenderFns } from "./SelectGrammar.vue?vue&type=template&id=0fadc5b4&scoped=true&"
import script from "./SelectGrammar.vue?vue&type=script&lang=js&"
export * from "./SelectGrammar.vue?vue&type=script&lang=js&"
import style0 from "./SelectGrammar.vue?vue&type=style&index=0&id=0fadc5b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fadc5b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow,VSelect,VSpacer})
